import type { VendorService } from '../enums/vendor-service.enum.js'

/**
 * Where a vendor opens one of its events: the event's own page for its
 * planner, who works on it, and the read-only vendor page for anyone else
 * (docs/planner-vendors.md, decision 17). The web app's links and an emailed
 * invitation's landing both use it, so the two cannot disagree.
 */
export function vendorEventPath(eventId: string, services: readonly VendorService[]): string {
  return services.includes('planning') ? `/events/${eventId}` : `/vendor/events/${eventId}`
}
